import ApiService from "../../api/api.service";
import JwtService from "../../common/jwt.service";

import { SET_ERROR, CLEAR_ERRORS, RESET_AUTH, SET_RESULT_DATA, CLEAR_RESULT_DATA } from "../mutations.type";
import { ADMINLOGOUT, GET_API, POST_API, PUT_API, DELETE_API, UPDATE_AUTH_POST_API, UPDATE_AUTH_PUT_API, SET_PROFILE_DATA } from "../actions.type";

export default {
    state: {

    },
    getters: {
    },
        
    actions: {

    	[GET_API](context, credentials) {console.log(context);
            return new Promise((resolve, reject) => {
                ApiService.setHeader();
                ApiService.get(credentials.api)
                 .then(({ data }) => {
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.success)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                                context.commit(
                                    SET_RESULT_DATA, { resultData: data }
                                );
                                resolve(data);
                            }
                        })
                        .catch(({ data }) => {
                            // console.log(data)
                            console.log("Something went wrong1");
                        });
                })
                .catch(data => {
                   
                    // if(data.getters.getErrors == "Your session has been expired, please login again")
                    // {
                           
                    //     context.commit(ADMINLOGOUT);
                    //     window.location.replace('/login');
                           
                    // }
                    // else
                    // {
                        // console.log(data.getters,"get");
                    // }
                    console.log("Something went wrong2");
                });
        },
        [POST_API](context, credentials) {
            return new Promise((resolve, reject) => {
                    ApiService.setHeader();
                   
                    ApiService.post(credentials.api, credentials.data)
                        .then(({ data }) => {
                           if (data.message == 'Unauthenticated') {
                             window.location.replace('/');
                           }
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.status)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                              
                                if(credentials.action == "category_data"){
                                    context.commit(
                                    credentials.action, { resultData: data }
                                );
                                }else if (credentials.action == "saving_accounts") {
                                   context.commit(
                                    credentials.action, { resultData: data }
                                );
                                } else {
                                    context.commit(
                                        SET_RESULT_DATA, { resultData: data }
                                    );
                                }
                                resolve(data);
                            }
                        })
                        .catch(({ response }) => {
                            
                            console.log("Something went wrong");
                        });
                })
                .catch(response => {
                     console.log(response,'post');
                    if(response.logout == true)
                    {
                           
                        context.commit(CLEAR_ERRORS);
                        context.commit(RESET_AUTH);
                        // console.log("akhya");
                        // context.commit(RESET_AUTH);
                        // resolve(data);
                       window.location.replace('/');
                           
                    }
                    console.log("Something went wrong");
                });
        },
        
         [PUT_API](context, credentials) {
            return new Promise((resolve, reject) => {
                    ApiService.setHeader();
                    ApiService.put(credentials.api+credentials.data.id, credentials.data)
                        .then(({ data }) => {
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.success)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                                
                                context.commit(
                                    SET_RESULT_DATA, { resultData: data.data }
                                );
                                resolve(data);
                            }
                        })
                        .catch(({ response }) => {
                            console.log("Something went wrong");
                        });
                })
                .catch(response => {
                    // if(response.logout == true)
                    // {
                           
                    //     context.commit(ADMINLOGOUT);
                    //     window.location.replace('/login');
                           
                    // }
                    console.log("Something went wrong");
                });

        },
        [DELETE_API](context, credentials) {
            // console.log(credentials.data)
            return new Promise((resolve, reject) => {
                    ApiService.setHeader();
                    ApiService.delete(credentials.api+credentials.data.id, credentials.data)
                        .then(({ data }) => {
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.success)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                                context.commit(
                                    SET_RESULT_DATA, { resultData: data }
                                );
                                resolve(data);
                            }
                        })
                        .catch(({ response }) => {
                            console.log("Something went wrong");
                        });
                })
                .catch(response => {
                    // if(response.logout == true)
                    // {
                           
                    //     context.commit(ADMINLOGOUT);
                    //     window.location.replace('/login');
                           
                    // }
                    console.log("Something went wrong");
                });
        },
        [UPDATE_AUTH_PUT_API](context, credentials) {
            // console.log(credentials.data)
            return new Promise((resolve, reject) => {
                ApiService.setMultipartHeader();
                    ApiService.setHeader();
                    ApiService.put(credentials.api+credentials.data.id, credentials.data)
                        .then(({ data }) => {
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.success)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                                context.commit(
                                    SET_PROFILE_DATA, { resultData: data }
                                );
                                context.commit(
                                    SET_RESULT_DATA, { resultData: data }
                                );
                                resolve(data);
                            }
                        })
                        .catch(({ response }) => {

                            console.log("Something went wrong");
                        });
                })
                .catch(response => {
                    // if(response.logout == true)
                    // {
                           
                    //     context.commit(ADMINLOGOUT);
                    //     window.location.replace('/login');
                           
                    // }
                    console.log("Something went wrong");
                });
        },
        [UPDATE_AUTH_POST_API](context, credentials) {
            // console.log(credentials.data)
            return new Promise((resolve, reject) => {
                ApiService.setMultipartHeader();
                    ApiService.setHeader();
                    ApiService.post(credentials.api, credentials.data)
                        .then(({ data }) => {
                            context.commit(CLEAR_ERRORS);
                            if (!Boolean(data.success)) {
                                context.commit(
                                    SET_ERROR, { message: data.message }
                                );
                                reject(data);
                            } else {
                                context.commit(
                                    SET_PROFILE_DATA, { resultData: data }
                                );
                                context.commit(
                                    SET_RESULT_DATA, { resultData: data }
                                );
                                resolve(data);
                            }
                        })
                        .catch(({ response }) => {
                            console.log("Something went wrong");
                        });
                })
                .catch(response => {
                    // if(response.logout == true)
                    // {
                           
                    //     context.commit(ADMINLOGOUT);
                    //     window.location.replace('/login');
                           
                    // }
                    console.log("Something went wrong");
                });
        },
        
    }
}
